import { Buffer } from 'buffer';

export default function getSvgImgSrc(svg) {
  const buff = Buffer.from(svg);
  const base64data = buff.toString('base64');
  return `data:image/svg+xml;base64,${base64data}`;
}